export default "__VITE_ASSET__88b75bcc__"